export default (theme) => ({
  card: {
    height: 295
  },
  title: {
    fontSize: '18px'
  },
  titleContainer: {
    padding: 10
  },
  cardContent: {
    padding: ['10px', '!important'],
    position: 'relative',
    height: 185
  },
  cell: {
    paddingTop: 8,
    paddingBottom: 8
  },
  viewText: {
    textDecoration: 'underline',
    color: '#0645AD'
  },
  row: {
    cursor: 'pointer'
  },
  buttonContainer: {
    paddingRight: 10,
    textAlign: 'right',
    paddingTop: 1
  },
  noEvents: {
    lineHeight: '215px',
    textAlign: 'center',
    fontSize: '16px'
  },
  titleSkeleton: {
    marginLeft: 10,
    marginTop: 10
  },
  rowSkeleton: {
    marginBottom: 10,
  }
});
